interface Props {
    message?: string
  }
  
  export default function ErrorMsg({ message }: Props) {
    if (!message) return null
    return (
      <p className="text-[11px] text-[#E74C3C] mt-1 font-medium" role="alert">
        {message}
      </p>
    )
  }